const styles = (theme) => ({
  root: {
    // backgroundColor:grey[100],
  },
  updateBtn: {
    float: "right",
  },
  updateProgress: {
    margin: "5px 0",
  },
  tagInput: {
    zIndex: 10,
    // height:150
  },
  textField:{
    width: "50%"
  },
  flexRowCenter: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "flex-end",
    alignContent: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
});

export default styles;
